import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { min } from 'rxjs/operators';
import { SyncHpcConfig, ConfigParameter, StorageProp } from 'src/app/core/models/config-entities';
import { ConfigEntityService } from 'src/app/core/services/config-entity.service';
import { SaveDeploymentSettingsComponent } from 'src/app/modules/deployment/modals/save-deployment-settings/save-deployment-settings.component';
import { AuthenticationService } from '../../../../core/services/authentication.service';
import { NavigationService } from '../../../../core/services/navigation.service';
import { UserRoleNames } from 'src/app/core/models/users';

@Component({
  selector: 'app-storage-setting',
  templateUrl: './storage-setting.component.html',
  styleUrls: ['./storage-setting.component.scss']
})
export class StorageSettingComponent implements OnInit {

  storageName: string = this.route.snapshot.params['storageName'] || this.route.parent.snapshot.params['storageName'];;
  depName: string = this.route.snapshot.params['deploymentName'] || this.route.parent.snapshot.params['deploymentName'];;
  storageConfigForm: UntypedFormGroup;
  configParameters: ConfigParameter[];
  loggedInUserRole: string = this.authenticationService.getRole() || "";
  isMonitor: boolean = this.loggedInUserRole == UserRoleNames.Reader;

  constructor(private route: ActivatedRoute,
    private _router: Router,
    private navService: NavigationService,
    private configEntityService: ConfigEntityService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this.storageConfigForm = new UntypedFormGroup({
    })
    this.loadStorageConfigData();
  }

  loadStorageConfigData() {
    this.configEntityService.getStorageConfig(this.depName, this.storageName).subscribe({
      next: (data) => {
        this.configParameters = <ConfigParameter[]>JSON.parse(JSON.stringify(data));
        this.configParameters.forEach((param) => {
          this.storageConfigForm.addControl(param.parameterName, new UntypedFormControl(param.parameterValue))
        });
      }, error: (err) => { }
    })
  }

  onSave(form) {
    let dialogRef = this.dialog.open(SaveDeploymentSettingsComponent, {
      disableClose: true,
      width: '400px',
      data: {
        title: 'Save Changes',
        message: 'Do you want to save the changes ?'
      }
    })
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        let storageParams: ConfigParameter[] = [];
        Object.keys(this.storageConfigForm.controls).forEach(key => {
          let configParam = this.configParameters.find(x => x.parameterName == key);
          storageParams.push({
            parameterName: key,
            parameterValue: this.storageConfigForm.controls[key].value,
            parameterTypeBoolean: configParam.parameterTypeBoolean,
            parameterDescription: configParam.parameterDescription,
            parameterSection: configParam.parameterSection,
            parameterDisplayName: configParam.parameterDisplayName,
            parameterDisabled: configParam.parameterDisabled,
            parameterSettingType: configParam.parameterSettingType,
           
          })
        });

        let storageConfig = new SyncHpcConfig(storageParams);

        this.configEntityService.updateStorageConfig(this.depName, this.storageName, storageConfig).subscribe({
          next: (data) => {
            setTimeout(() => {
              this.loadStorageConfigData()
            }, 1000);
            // this.snackBar.open('Settings has been Updated Successfully.', 'Ok', {
            //   duration: 3000
            // })
            window.location.reload();
          }
        })
      }
    })
  }

  onReset() {
    let dialogRef = this.dialog.open(SaveDeploymentSettingsComponent, {
      disableClose: true,
      width: '400px',
      data: {
        title: 'Reset Confirmation',
        message: 'Do you want to reset the changes ?'
      }
    })
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.loadStorageConfigData()
      }
    })
  }

  redirectTo() {
    this.navService.sendParentData('')
    this._router.navigate(['../../../..'], { relativeTo: this.route })
  }
}
